import React,{useState,useEffect} from 'react';
import {Redirect} from 'react-router-dom'
import Home from './home'
export default()=>{
    const [login, setLogin] = useState(true);
  useEffect(() => {
 const token=localStorage.getItem("aptitude_test_token");
 if(!token)
 setLogin(false)


       },[]
    );
    if(!login) 
  return(
<Redirect to="/aptitude-test-result/login"/>
  )
  return(
    <Home/>
  )
}
